import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface Alert {
  visible: boolean;
  message?: string | string[];
  type?: "error" | "success" | "warning" | "info";
  top?: boolean;
  handleClose?: () => void;
  isIntl?: boolean;
  textClose?: string;
}

const initialState = {
  visible: false,
  message: "",
  type: "error",
  textClose: "textClose",
  top: false,
  handleClose: undefined,
  isIntl: true,
} as Alert;

const alertSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    showAlert: (state, action: PayloadAction<Alert>) => {
      state.message = action.payload.message || "defaultError";
      state.visible = true;
      state.type = action.payload.type || "error";
      state.top = action.payload.top;
      state.handleClose = action.payload.handleClose;
      state.textClose = action.payload.textClose;
      state.isIntl = action.payload.isIntl;
    },
    hideAlert: (state) => {
      state.visible = false;
    },
  },
});

export const { showAlert, hideAlert } = alertSlice.actions;

export default alertSlice.reducer;
